module.exports = __webpack_public_path__ + "static/img/vu.f243acac.svg";